export default function siteCursor () {
	const cursor = document.querySelector('.site-cursor');
	const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
	if (! cursor || ! finePointer) return;

	let x = 0;
	let y = 0;
	let tx = 0;
	let ty = 0;
	let ready = false;

	const tick = () => {
		x += (tx - x) * 0.18;
		y += (ty - y) * 0.18;
		cursor.style.left = x + 'px';
		cursor.style.top = y + 'px';
		requestAnimationFrame(tick);
	};
	tick();

	const place = (event) => {
		tx = event.clientX;
		ty = event.clientY;
		if (! ready) {
			x = tx;
			y = ty;
			ready = true;
		}
		cursor.classList.add('is-on');

		const target = event.target instanceof Element ? event.target : null;
		const native = target?.closest('input, textarea, select, [contenteditable="true"]');
		const playing = target?.closest('.media-row .item.is-playing');
		const play = ! native && ! playing && target?.closest('[data-cursor="play"]');
		const arrow = ! native && ! play && target?.closest('[data-cursor="arrow"]');
		const gone = ! native && ! play && ! arrow && target?.closest('a, button, .action');
		cursor.classList.toggle('is-native', Boolean(native));
		cursor.classList.toggle('is-play', Boolean(play));
		cursor.classList.toggle('is-arrow', Boolean(arrow));
		cursor.classList.toggle('is-hidden', Boolean(gone));
	};

	document.addEventListener('mousemove', place);
	document.documentElement.addEventListener('mouseleave', () => {
		cursor.classList.remove('is-on', 'is-arrow', 'is-play', 'is-native', 'is-hidden');
	});
}
